const runtimeConfig = typeof window !== 'undefined' ? (window.__APP_CONFIG__ ?? {}) : {};

const readConfig = (key, fallback = '') => {
  const runtimeValue = runtimeConfig[key];
  if (typeof runtimeValue === 'string' && runtimeValue.trim() !== '') {
    return runtimeValue;
  }

  const buildTimeValue = process.env[key];
  if (typeof buildTimeValue === 'string' && buildTimeValue.trim() !== '') {
    return buildTimeValue;
  }

  return fallback;
};

const appConfig = Object.freeze({
  apiBaseUrl: readConfig('REACT_APP_API_BASE_URL'),
  brandAspName: readConfig('REACT_APP_BRAND_ASP_NAME'),
  brandEmail: readConfig('REACT_APP_BRAND_EMAIL'),
  brandFaviconPath: readConfig('REACT_APP_BRAND_FAVICON_PATH', '/marmin_favicon.ico'),
  brandLogoPath: readConfig('REACT_APP_BRAND_LOGO_PATH', '/marmin_logo.png'),
  brandName: readConfig('REACT_APP_BRAND_NAME', 'UAE E-Invoicing'),
  cookieDomain: readConfig('REACT_APP_COOKIE_DOMAIN'),
  developerDashboardUrl: readConfig('REACT_APP_DEVELOPER_DASHBOARD_URL'),
  helpAndSupportUrl: readConfig('REACT_APP_HELP_AND_SUPPORT_URL'),
  productWikiUrl: readConfig('REACT_APP_PRODUCT_WIKI_URL'),
  stripeCurrency: readConfig('REACT_APP_STRIPE_CURRENCY', 'AED'),
  appEnv: readConfig('REACT_APP_ENV_NAME', ''),
  vendorSlug: readConfig('REACT_APP_VENDOR_SLUG', 'marmin'),
  termsUrl: readConfig('REACT_APP_TERMS_URL'),
  privacyUrl: readConfig('REACT_APP_PRIVACY_URL'),
});

const updateLinkHref = (selector, href) => {
  if (!href) {
    return;
  }

  const linkElement = document.querySelector(selector);
  if (linkElement) {
    linkElement.href = href;
  }
};

export const withBrandName = (value) => String(value ?? '').replaceAll('{brandName}', appConfig.brandName);

export const applyDocumentBranding = () => {
  if (typeof document === 'undefined') {
    return;
  }

  if (appConfig.brandName) {
    document.title = appConfig.brandName;
  }

  updateLinkHref('link[rel="icon"]', appConfig.brandFaviconPath);
  updateLinkHref('link[rel="apple-touch-icon"]', appConfig.brandLogoPath);
};

export default appConfig;
